let images = [];
let loadDeferredThrottleTimeout;

document.addEventListener("DOMContentLoaded", () => {
    images = Array.from(document.querySelectorAll('[data-srcset]'));

    images.forEach(loadImage);
})

export function loadDeferred() {
    if(loadDeferredThrottleTimeout) {
        clearTimeout(loadDeferredThrottleTimeout);
    }

    loadDeferredThrottleTimeout = setTimeout(() => {
        images.filter(elementInViewport).forEach((image) => {
            images.splice(images.indexOf(image), 1);
            loadImage(image);
        })
    }, 20);
}

function loadImage(image) {
    const loader = new Image();
    loader.addEventListener('load', () => {
        image.srcset = image.dataset.srcset;
        image.removeAttribute('data-srcset');
    });
    loader.sizes = image.sizes;
    loader.srcset = image.dataset.srcset;
}

function elementInViewport(el) {
    const rect = el.getBoundingClientRect()

    return (
        rect.bottom >= 0
        && rect.right >= 0
        && rect.top <= (window.innerHeight || document.documentElement.clientHeight)
        && rect.left <= (window.innerWidth || document.documentElement.clientWidth)
    )
}
